import { SVGProps } from 'react';
interface SVGRProps {
    title?: string;
    titleId?: string;
}
export const IconBuildingSkyscraper = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 24 24"
        display="block"
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M13.526 2.15A1 1 0 0 1 14 3v3.465l5.555 3.703A1 1 0 0 1 20 11v9h1a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2h1V7a1 1 0 0 1 .553-.894l8-4a1 1 0 0 1 .973.043M6 20h6V4.618l-6 3zm8-11.131V20h4v-8.465zM9 8a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1m0 3a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0V12a1 1 0 0 1 1-1m0 3a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0V15a1 1 0 0 1 1-1m0 3a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0V18a1 1 0 0 1 1-1"
            clipRule="evenodd"
        />
    </svg>
);
